import { FC } from "react";
import { NavLink } from "react-router-dom";
import { RPFormattedMessage } from "@src/i18n";
import {
  CompanyAccountStatus,
  LicenseStatus,
  useOrderInfo,
  useOrgInfo,
  useUserInfo,
  useUserManualReportAccessPermission,
} from "@src/common/reliablePartnerApi";
import { CurrentOrgLink } from "@src/MainContent";
import { useAppSelector } from "@src/reduxStore";

const SubMenu: FC = () => {
  const canManageManualReports = useUserManualReportAccessPermission();
  const selectedOrgId = useAppSelector(state => state.common.selectedOrgId);
  const hasOrgContext = useAppSelector(state => state.common.hasOrgContext);
  const userInfo = useUserInfo();
  const isAdmin = userInfo.data?.isAdmin;
  const userOrg = userInfo.data?.companies.find(
    org => org.qvarnId === selectedOrgId
  );
  const isRPUser = userOrg?.permissions.includes("rp_user");
  const orgInfo = useOrgInfo();
  const orgOK =
    orgInfo.data?.companyAccountStatus === CompanyAccountStatus.ACTIVE;
  const orderInfo = useOrderInfo();
  const licenseOK = orderInfo.data?.license?.status === LicenseStatus.ACTIVE;
  const config = useAppSelector(state => state.common.config);

  return (
    <nav
      className="stv-secondary-nav navbar navbar-toggleable-sm"
      role="navigation"
    >
      <button
        id="topMenuCollapse"
        className="navbar-toggler navbar-toggler-right collapsed d-flex d-md-none align-items-center"
        type="button"
        data-toggle="collapse"
        data-target="#subMenu"
        aria-controls="subMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon d-flex align-items-center justify-content-center">
          &#9776;
        </span>
      </button>
      <span className="navbar-brand">&nbsp;</span>
      <div
        className="collapse navbar-collapse"
        id="subMenu"
        aria-expanded="false"
      >
        <ul className="navbar-nav nav-tabs w-100 text-right text-md-center">
          <li className="nav-item icon">
            <a
              className="nav-link"
              id="subMenuPortalLink"
              href={config?.portalUrl}
            >
              <i className="fa fa-home fa-inverse" />
            </a>
          </li>
          {((isRPUser && licenseOK && orgOK) || isAdmin) && (
            <li className="nav-item">
              <CurrentOrgLink
                to=""
                className="nav-link"
                isActive={(match, location) => {
                  if (match?.isExact) {
                    return true;
                  }
                  // Frontpage contains tabbed views.
                  // The other is mounted in the root, which is caught
                  // by the `.isExact` above. The other is details-view
                  // mounted under /orgs/<orgid>/details.
                  const parts = location.pathname.split("/");
                  if (
                    parts.length > 3 &&
                    parts[1] === "orgs" &&
                    parts[3] === "details"
                  ) {
                    return true;
                  }
                  return false;
                }}
              >
                <b className="ml-2 mr-2">
                  <RPFormattedMessage id="subMenuHome" defaultMessage="KOTI" />
                </b>
              </CurrentOrgLink>
            </li>
          )}
          <li className="ml-md-auto" />
          {hasOrgContext && (orgOK || isAdmin) && (
            <li className="nav-item">
              <CurrentOrgLink to="/order" className="nav-link">
                <b className="ml-2 mr-2">
                  <RPFormattedMessage
                    id="subMenuOrder"
                    defaultMessage="TILAUS"
                  />
                </b>
              </CurrentOrgLink>
            </li>
          )}
          {canManageManualReports && (
            <li className="nav-item">
              <NavLink to="/admin" className="nav-link">
                <b className="ml-2 mr-2">
                  <RPFormattedMessage
                    id="subMenuAdmin"
                    defaultMessage="ADMIN"
                  />
                </b>
              </NavLink>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default SubMenu;
